export const VITRINE_DEFAULTS = {
  hero_tagline: "Un cadre chaleureux a l'ambiance du Sud-Ouest, des plats copieux et un accueil tres sympathique",
  hero_image: "/images/restaurant/01-fullsizerender1-1040.jpg",
  logo_size: 420,
  about_title: "Un cadre chaleureux a l'ambiance du Sud-Ouest",
  about_text1: "Situe en plein coeur de Cayenne, toute l'equipe du restaurant La Taverne vous accueille du lundi au samedi de 12h00 a 14h30 et de 19h00 a 22h30.",
  about_text2: "Si Vous voulez deguster de bonnes viandes dans un cadre chaleureux, passer un agreable moment en famille ou entre amis, ou dans un cadre plus intime...",
  about_text3: "La Taverne vous propose ses specialites du sud-ouest et ses grillades.",
  about_image1: "/images/restaurant/04-storefront.jpg",
  about_image2: "/images/restaurant/10-steak-hache.jpeg",
  about_image3: "/images/restaurant/04-storefront.jpg",
  cta_title: "Reservez votre table",
  cta_subtitle: "Appelez-nous ou passez nous voir directement",
  cta_image: "/images/restaurant/11-assaisonnement.jpg",
  phone: "0594 29 04 66",
  address: "26 Rue Mole, 97300 Cayenne, Guyane Francaise",
  hours_label: "Lundi au Samedi",
  hours_text: "12h00 - 14h30 & 19h00 - 22h30",
  hours_closed: "Ferme le dimanche",
};

export function formatVitrineHours(vitrine) {
  const parts = [];
  if (vitrine.hours_label && vitrine.hours_text) {
    parts.push(`${vitrine.hours_label}: ${vitrine.hours_text}`);
  } else if (vitrine.hours_text) {
    parts.push(vitrine.hours_text);
  } else if (vitrine.hours_label) {
    parts.push(vitrine.hours_label);
  }
  if (vitrine.hours_closed) {
    parts.push(vitrine.hours_closed);
  }
  return parts.join(' — ');
}
